module.exports = __webpack_public_path__ + "img/rank-1.96c7ac25.png";